<script setup lang="ts">
interface TagCardProps {
  title?: string;
}

const props = defineProps<TagCardProps>();
</script>

<template>
  <span class="tag-card align-items-center">{{ props.title }}</span>
</template>
